export enum PHONE_CONFIRMATION_TYPE {
  LCO = 'LCO',
  CONTACT_TRACING = 'CONTACT_TRACING',
  PROMO = 'PROMO',
}
